import { FormHelperText, Typography, TextField } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NumberFormatCustom } from "../../../helper/numberFormat";

const CoreInput = (props) => {
  const {
    className,
    control,
    name,
    label,
    placeholder,
    InputLabelProps,
    inputProps,
    InputProps,
    required,
    readOnly,
    type,
    multiline,
    minRows,
    maxRows,
    hidden,
    helperText,
    allowTranslation,
    disabled,
    rules,
    ...restProps
  } = props;

  const [disabledField, setDisabled] = useState(disabled);

  const { t } = useTranslation("common");

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  if (hidden) {
    return null;
  }
  let { transform } = props;

  if (type === "number") {
    transform = {
      input: (value) => value,
      output: (e) => {
        const output = e.target.value;
        return e.target.value?.length > 0
          ? Number.isNaN(output)
            ? 0
            : Number(output)
          : null;
      },
    };
  }

  return (
    <div className={className}>
      <Controller
        control={control}
        name={name}
        render={({
          field: { onChange, onBlur, value, ref },
          fieldState: { error },
        }) => (
          <>
            <TextField
              fullWidth
              type={type === "number" ? "text" : type}
              label={label}
              placeholder={
                placeholder ??
                t("form.input.placeholder", { label: label?.toLowerCase() })
              }
              onChange={(e) => onChange(transform.output(e))}
              // onBlur={onBlur}
              onBlur={(e) => {
                onChange(e.target.value?.trim());
              }}
              value={value ? transform.input(value) : value?.toString() ?? ""}
              inputRef={ref}
              multiline={multiline}
              minRows={minRows}
              maxRows={maxRows}
              disabled={disabledField}
              error={!!error}
              helperText={error && error.message}
              InputLabelProps={{
                shrink: placeholder ? true : undefined,
                required,
                ...InputLabelProps,
              }}
              inputProps={{
                readOnly,
                ...inputProps,
              }}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              InputProps={{
                ...InputProps,
                ...(type === "number" && {
                  inputComponent: NumberFormatCustom,
                }),
              }}
              {...restProps}
            />
            {helperText && (
              <Typography className="italic text-[#747475] text-[12px]">
                {helperText}
              </Typography>
            )}
          </>
        )}
        rules={{
          required: required
            ? t("validation.enter", { msg: label ?? name })
            : false,
          ...rules,
        }}
      />
    </div>
  );
};

CoreInput.defaultProps = {
  className: null,
  label: null,
  placeholder: null,
  transform: {
    input: (value) => value,
    output: (e) => e,
  },
  InputLabelProps: null,
  inputProps: null,
  InputProps: null,
  required: false,
  type: "text",
  multiline: false,
  minRows: 5,
  maxRows: null,
  disabled: false,
  allowTranslation: false,
};

CoreInput.propTypes = {
  className: PropTypes.string,
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  transform: PropTypes.object,
  InputLabelProps: PropTypes.object,
  inputProps: PropTypes.object,
  InputProps: PropTypes.object,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  type: PropTypes.string,
  multiline: PropTypes.bool,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  helperText: PropTypes.any,
  rules: PropTypes.object,
  allowTranslation: PropTypes.bool,
};

export default CoreInput;
